// SCSS
import '@/assets/styles/main.scss'

// JS
import Vue from 'vue'
import WebpPlugun from 'vue-webp-plugin'
import App from './App.vue'
import router from './router'
import store from './store'

import SetSvgHref from '@/helpers/set-svg-href'

import BaseButton from '@/components/base/BaseButton'
import BaseInput from '@/components/base/BaseInput'
import BaseList from '@/components/base/BaseList'
import BasePicture from '@/components/base/BasePicture'

require.context(`@/assets/sprite/`, true, /i-.*\.svg$/i).keys().forEach((it) => it)

Vue.config.productionTip = false

Vue.use(WebpPlugun)
Vue.use(SetSvgHref)

Vue.component('BaseButton', BaseButton)
Vue.component('BaseInput', BaseInput)
Vue.component('BaseList', BaseList)
Vue.component('BasePicture', BasePicture)

Vue.directive('scroll', {
  inserted (el, binding) {
    const f = (evt) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
